import { render, staticRenderFns } from "./Page.vue?vue&type=template&id=30dc964a&"
import script from "./Page.vue?vue&type=script&lang=js&"
export * from "./Page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/digital-seaside/sst-admin-panel/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('30dc964a')) {
      api.createRecord('30dc964a', component.options)
    } else {
      api.reload('30dc964a', component.options)
    }
    module.hot.accept("./Page.vue?vue&type=template&id=30dc964a&", function () {
      api.rerender('30dc964a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/page/Page.vue"
export default component.exports